import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {Observable} from 'rxjs'
import {
  AuditRequest,
  AuditResults,
} from '@app/core/services/audit/audit.interface'

@Injectable()
export class AuditService {
  constructor(private http: HttpClient) {}

  public getTerminalLog(
    terminal: number,
    page: number,
    pageSize: number,
  ): Observable<AuditResults> {
    const url = 'api://Data/Audit'
    const body: AuditRequest = {
      index: 'Audit',
      filters: [
        {
          type: 'term',
          field: 'changes.objectReference',
          matches: 'c-t-' + terminal,
        },
      ],
      query: '',
      maxResults: pageSize,
      offset: (page - 1) * pageSize,
      sorts: [
        {
          field: '@timestamp',
          asc: false,
        },
      ],
    }
    return this.http.post<AuditResults>(url, body)
  }
}
